import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Stack } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { TabLink, TabNav } from '@eluve/smart-blocks';

import { PatientProfile } from './PatientProfile';
import { TabActionsSlotContext } from './TabActionsSlotContext';

export const MedicalProfile: React.FC = () => {
  const { t } = useTranslation();
  // The tab bar's right-hand actions slot, handed to the active sub-tab via
  // context so it can portal its own tab-scoped controls beside the tabs.
  const [actionsSlot, setActionsSlot] = useState<HTMLDivElement | null>(null);

  // "Medical Profile" tab: the FHIR record (PatientProfile) is the always-on
  // header; data views below switch via the secondary tab bar + nested Outlet.
  const subTabs: TabLink[] = [
    { name: t('patients.tabs.careTeam'), link: 'care-team' },
    { name: t('patients.tabs.observations'), link: 'observations' },
    { name: t('patients.tabs.patientUploads'), link: 'patient-uploads' },
  ];

  return (
    <Stack gap={6}>
      <PatientProfile />
      <Stack gap={4}>
        <TabNav
          tabs={subTabs}
          actions={<div ref={setActionsSlot} className="flex items-center" />}
        />
        <TabActionsSlotContext.Provider value={actionsSlot}>
          <Outlet />
        </TabActionsSlotContext.Provider>
      </Stack>
    </Stack>
  );
};
